import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Every navigation should start at the top of the new page. Without this the
 * browser keeps the previous scroll offset, so following a link from far down
 * the homepage lands the visitor at the bottom of the next page.
 */
export const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // in-page anchors handle their own scrolling
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
